import { ref } from 'vue'
import { getGroupImgMsgUrls } from '@/api/chat.js'

export default function useImagePreview(activeKey) {
  // 预览图片集合
  const srcList = ref([])
  // 预览图片实例
  const imageViewerRef = ref(null)
  // 图片预览是否可见
  const imageViewerVisible = ref(false)
  //正在预览的图片消息id
  const previewImgId = ref('')
  // 图片预览是否可见
  const setImageViewerVisible = status => {
    imageViewerVisible.value = status
    if (!status) previewImgId.value = undefined
  }
  // 获取群聊图片列表
  const getImgMsgUrls = async () => {
    if (!activeKey.value) return
    const result = (await getGroupImgMsgUrls({ groupId: activeKey.value })) || []
    srcList.value = result
  }
  //设置预览图片消息id
  const setPreviewImgId = (item, type) => {
    previewImgId.value = item.mid
    if (type === 'img') setImageViewerVisible(true)
  }
  return {
    srcList,
    imageViewerRef,
    imageViewerVisible,
    previewImgId,
    setPreviewImgId,
    getImgMsgUrls,
    setImageViewerVisible
  }
}
